/**
 * menuHorizontal.js
 */

// Import
import './menuHorizontal.scss';
import $ from 'jquery';

$(document).ready(function() {

    const $dropdown = $("#horizontal-menu .dropdown");
    const $dropdownToggle = $("#horizontal-menu .dropdown-toggle");
    const $dropdownMenu = $("#horizontal-menu .dropdown-menu");
    const showClass = "show";

    // Hover : affichage via classe .show (sans inline style pour ne pas bloquer les clics)
    $dropdown.hover(
        function() {
            const $this = $(this);
            $this.addClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "true");
            $this.children($dropdownMenu).addClass(showClass);
        },
        function() {
            const $this = $(this);
            $this.removeClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "false");
            $this.children($dropdownMenu).removeClass(showClass);
        }
    );

    // Clic : handler direct sur l'élément, s'exécute avant les handlers document-level de Bootstrap.
    // stopPropagation empêche Bootstrap (_clearMenus + toggle) de court-circuiter notre logique.
    $dropdownToggle.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $parent = $(this).parent();
        const $menu = $parent.children($dropdownMenu);

        if ($parent.hasClass(showClass)) {
            $parent.removeClass(showClass);
            $menu.removeClass(showClass);
            $(this).attr('aria-expanded', 'false');
        } else {
            $parent.addClass(showClass);
            $menu.addClass(showClass);
            $(this).attr('aria-expanded', 'true');
        }
    });

});

